import React from 'react';
import {useIntl} from 'react-intl';
import {Bold, Code, Italic, Strikethrough} from 'lucide-react';
import {
    BOLD_MARKER,
    CODE_MARKER,
    ITALIC_MARKER,
    STRIKETHROUGH_MARKER,
    type FormattingMarker,
} from '../../utils/composerFormatting';

interface ComposerFormattingToolbarProps {
    onFormat: (marker: FormattingMarker) => void;
    disabled?: boolean;
}

const ComposerFormattingToolbar: React.FC<ComposerFormattingToolbarProps> = ({onFormat, disabled}) => {
    const intl = useIntl();

    const buttons: Array<{id: string; marker: FormattingMarker; icon: React.ReactNode; labelId: string}> = [
        {id: 'bold', marker: BOLD_MARKER, icon: <Bold size={16}/>, labelId: 'chat.composer.format.bold'},
        {id: 'italic', marker: ITALIC_MARKER, icon: <Italic size={16}/>, labelId: 'chat.composer.format.italic'},
        {id: 'strikethrough', marker: STRIKETHROUGH_MARKER, icon: <Strikethrough size={16}/>, labelId: 'chat.composer.format.strikethrough'},
        {id: 'code', marker: CODE_MARKER, icon: <Code size={16}/>, labelId: 'chat.composer.format.code'},
    ];

    return (
        <div
            data-testid="chat.composer.formatting-toolbar"
            className="flex items-center gap-1 mb-2"
        >
            {buttons.map(button => {
                const label = intl.formatMessage({id: button.labelId});
                return (
                    <button
                        key={button.id}
                        type="button"
                        data-testid={`chat.composer.format-${button.id}-btn`}
                        aria-label={label}
                        title={label}
                        disabled={disabled}
                        onMouseDown={event => event.preventDefault()}
                        onClick={() => onFormat(button.marker)}
                        className="p-1 rounded hover:bg-surface-muted text-ink-muted-strong"
                    >
                        {button.icon}
                    </button>
                );
            })}
        </div>
    );
};

export default ComposerFormattingToolbar;
